import { useQuery, useQueryClient } from "@tanstack/react-query"
import { getToken } from "../../../services/Help/help.service"
import useUser from "../../Shared/UserProvider/useUser"
import { useEffect } from "react";


export const useHelpToken = () => {
    const {isLoggedIn} = useUser();
    const queryClient = useQueryClient();
    const query =  useQuery({
     queryKey: ['help','token'],
     queryFn: () => getToken(),
     staleTime: 1000 * 60 * 60 * 3, // 3 hours
     enabled: isLoggedIn
    });

    useEffect(() => {
        queryClient.invalidateQueries({ queryKey: ['help','token'] });
    },[isLoggedIn,queryClient])

    return query;
 }
 